<template>
	<div style="background-color: white;">
		<div style="display: flex; width: 100%; flex-direction: column; align-items: center; justify-content: center;">
			<!-- 相册图片 -->
			<span class="text">当前状态:{{statusText}}</span>
			<!-- 上传图片功能 -->

			<input ref="imgFile" id="uploadImage" type="file" multiple accept="image/*" @change="selectImages"
				style="opacity: 0; position: absolute; width: 1px; height: 1px; z-index: -1;" />
			<div class="camera" @click="clickImgFile">
				<img class="icon" src="@/assets/icon_album1.png" alt="">
				<span class="text">上传图片</span>
			</div>
			<div v-if="!isImageSelected">


				<!-- 相册功能 -->


				<input ref="leftFile" id="upload" type="file" @change="fileChange($event)" accept="video/*"
					style="opacity: 0; position: absolute; width: 1px; height: 1px; z-index: -1;">
				<div class="camera" @click="clickFile">


					<img v-if="coverURL" :src="coverURL" alt="" class="icon" />
					<img v-else class="icon" src="@/assets/icon_album1.png" alt="">
					<span class="text">上传视频</span>
				</div>


				<!-- 拍摄功能 -->
				<input ref="rightFile" id="upload" type="file" @change="startRecord($event)" accept="video/*"
					capture="camcorder" style="opacity: 0; position: absolute; width: 1px; height: 1px; z-index: -1;">
				<div class="camera" @click="clickRecord">


					<img v-if="coverURL2" :src="coverURL2" alt="" class="icon" />
					<img v-else class="icon" src="@/assets/icon_shot1.png" alt="">
					<span class="text">拍摄</span>
				</div>

			</div>

		</div>
		<!-- 上传中弹窗 -->
		<div v-if="uploading" class="modal">
			<div class="modal-content">
				<p>上传中... {{ uploadProgress }}%</p>
				<progress :value="uploadProgress" max="100"></progress>
			</div>
		</div>

		<!-- 上传成功弹窗 -->
		<div v-if="uploadSuccess" class="modal">
			<div class="modal-content">
				<p>上传成功！</p>
			</div>
		</div>

		<!-- 处理中弹窗 -->
		<div v-if="processing" class="modal">
			<div class="modal-content">
				<p>视频转码中，请稍候...</p>
			</div>
		</div>
		<!-- 请先登录 -->
		<div v-if="isLogin" class="modal">
			<div class="modal-content">
				<p>请先登录</p>
			</div>
		</div>
		<!-- 文件不能为空 -->
		<div v-if="isFile" class="modal">
			<div class="modal-content">
				<p>文件不能为空</p>
			</div>
		</div>
		<!-- 报错 -->
		<div v-if="isError" class="modal">
			<div class="modal-content">
				<p>{{report_errors}}</p>
			</div>
		</div>
		<!-- 自定义弹窗 -->
		<div v-if="showModal" class="modal-mask">
			<div class="modal-container">
				<h3>提示</h3>
				<p>{{showModalMessage}}</p>
				<div class="modal-footer">
					<button @click="showModal = false">取消</button>
					<button @click="goToAuth">{{showModalBut}}</button>
				</div>
			</div>
		</div>
		<!-- 隐藏 video 和 canvas 用于处理视频第一帧 -->
		<video ref="videoEl" crossOrigin="anonymous" style="display: none" muted></video>
		<canvas ref="canvasEl" style="display: none"></canvas>
		<!-- 图片展示 -->
		<div class="image-grid" v-if="images.length > 0">
			<div class="image-wrapper" v-for="(img, index) in images" :key="index">
				<img :src="img" class="image" />
				<img class="delete-btn" @click="removeImage(index)" src="@/assets/icon_delete_img.png" alt="" />

			</div>
		</div>

		<!-- 保存功能 -->
		<div class="bottom_buttons">
			<!-- 取消按钮 -->
			<!-- <div class="button cancel_but" @click="onSave">
				<div class="button_text">保存</div>
			</div> -->
			<button class="button cancel_but" type="button" data-action="switchTab">取消</button>

			<button class="button next_but" type="button" data-action="navigateTo">下一步</button>

		</div>
		<!-- 底部按钮容器 -->
		<div class="tab-bar">

			<div v-for="(item, index) in list" :key="index"
				:class="['tab-item', currentIndex === index ? 'active' : '']" style="position: relative;"
				@click="onTabClick(index, item)">
				<img :src="currentIndex == index ? item.selectedIconPath : item.iconPath" class="tab-icon" />
				<span :style="{ fontSize: '11px', color: currentIndex === index ? selectedColor : color }">
					{{ item.text }}
				</span>
			</div>

		</div>

	</div>

</template>



<script type="text/javascript">
	import axios from 'axios'

	export default {
		data() {
			return {
				selectedVideo: '', // 用来存储选择的视频文件路径
				recordedVideo: '', // 用来存储拍摄的视频文件路径
				timeout: '',
				partSize: '',
				parallel: '',
				retryCount: '',
				retryDuration: '',
				region: 'cn-shanghai',
				userId: '1285730427558697',
				file: null,
				stsProgress: 0,
				uploadDisabled: true,
				resumeDisabled: true,
				pauseDisabled: true,
				statusText: '',
				images: [],
				uploader: null,
				maxRecordTime: 60, // 设置最大视频时长为 60秒
				uploading: false, // 控制上传进度条是否显示
				uploadProgress: 0, // 当前上传进度
				processing: false,
				uploadSuccess: false,
				isLogin: false,
				isFile: false,
				isError: false,
				uid_str: "",
				report_errors: '',
				is_shiming: 1,
				id: "",
				color: '#666666', // tabbar 未选中字体的颜色
				selectedColor: "#0975F7", // tabbar 选中字体的颜色
				currentIndex: 1,
				coverURLImg: '',
				coverURL: '',
				coverURL2: '',
				videoThumb: '',
				videoId: '',
				video_type: 1,
				showModal: false,
				showModalMessage: '',
				showModalBut: '去认证',
				isImageSelected: false,
				list: [{
						pagePath: '/pages/home/videohome',
						iconPath: 'https://app.kachez.cn/img/icon_home_nu.png',
						selectedIconPath: 'https://app.kachez.cn/img/icon_home.png',
						text: '首页'
					},
					{
						pagePath: '/pages/photograph/photograph2',
						iconPath: 'https://app.kachez.cn/img/icon_photograph_nu.png',
						selectedIconPath: 'https://app.kachez.cn/img/icon_photograph.png',
						text: '拍摄'
					},
					{
						pagePath: '/pages/mine/mine',
						iconPath: 'https://app.kachez.cn/img/icon_mine_nu.png',
						selectedIconPath: 'https://app.kachez.cn/img/icon_mine.png',
						text: '我的'
					}
				]
			};
		},
		onLoad(options) {
			console.log("JSBridge 获取 uid =", options);

		},
		mounted() {
			let self = this
			this.listenNativeMessage();
			this.uid_str = this.$fromMiniProgram.uid
			this.is_shiming = this.$fromMiniProgram.is_shiming
			console.log('👀 来自小程序的 UID:', this.$fromMiniProgram.uid);
			console.log('是否实名:', this.$fromMiniProgram.is_shiming);
			this.initUniAppBridge();


		},

		methods: {
			removeImage(index) {
				this.images.splice(index, 1);
				if (this.images.length === 0) {
					this.isImageSelected = false;
				}
				this.statusText = '已选择 ' + this.images.length + ' 张图片';

			},
			clickImgFile() {
				this.$refs.imgFile.click();
			},
			selectImages(event) {
				let self = this
				const files = Array.from(event.target.files);
				if (!files || files.length === 0) {
					alert("请选择图片");
					return;
				}

				// 当前已选图片数量 + 新增文件数量 > 9
				if (this.images.length + files.length > 9) {
					alert("最多只能选择 9 张图片");
					return;
				}

				const imageUrls = files.map(file => URL.createObjectURL(file));
				self.images = self.images.concat(imageUrls); // 追加新图
				self.isImageSelected = true;
				self.statusText = '已选择 ' + self.images.length + ' 张图片';
				console.log("images===", JSON.stringify(self.images))
				// 		self.images.forEach(item => {
				// 			self.uploader = self.createUploader()
				// 			var userData = '{"Vod":{}}';
				// 			this.uploader.addFile(item, null, null, null, userData)
				// 		})

				// 创建上传器
				self.uploader = self.createUploader();

				// 添加图片到上传队列
				for (let i = 0; i < self.images.length; i++) {
					let imageUrl = self.images[i];
					let userData = '{"Vod":{}}'; // 示例上传参数，根据业务调整
					self.uploader.addFile(imageUrl, null, null, null, userData);
				}

				// 清空 input 的 value，否则连续选择同一张图不会触发 change
				this.$refs.imgFile.value = '';
			},
			listenNativeMessage() {
				// 接收原生返回的图片路径（Base64 或 URL）
				window.addEventListener('message', (event) => {
					const data = event.data;
					if (typeof data === 'string') {
						try {
							const parsed = JSON.parse(data);
							if (parsed.imageUrl) {
								this.previewUrl = parsed.imageUrl;
							}
						} catch (e) {
							console.error('解析消息失败', e);
						}
					}
				});
			},

			getCustomerParamsFromUrl() {
				const hash = window.location.hash;
				const search = window.location.search;
				let paramStr = '';

				if (hash && hash.includes('=')) {
					// uniapp hash 路由情况
					paramStr = hash.split('?')[1] || '';
				} else if (search && search.includes('=')) {
					// 正常 query 情况
					paramStr = search.substring(1);
				}

				const params = {};
				if (paramStr) {
					paramStr.split('&').forEach(pair => {
						const [key, value] = pair.split('=');
						params[key] = decodeURIComponent(value || '');
					});
				}
				return params;
			},
			goToAuth() {
				this.showModal = false;
				uni.navigateTo({
					url: "/pages/Realnameauthentication/Realnameauthentication"
				});
			},
			//取消  重新上传
			cancelOnClick() {

				// this.uid_str = params.uid || '';
				// this.is_shiming = params.is_shiming || 1;
				setTimeout(() => {
					self.report_errors = "uid_str:" + this.uid_str;
					self.isError = true;
				}, 1000);
				//	self.isError = false;
				console.log("URL 参数 uid =", this.uid_str);
				console.log("URL 参数 is_shiming =", this.is_shiming);

			},
			onTabClick(index, item) {
				//alert('点击了：' + item.pagePath);
				uni.switchTab({
					url: item.pagePath
				});

			},

			initUniAppBridge() {
				let self = this
				window.addEventListener('message', function(e) {
					const {
						data
					} = e;

					if (data.type === 'videoSelected') {
						console.log('接收到小程序选中的视频路径:', data.videoPath);

						// 这里可以发起上传请求等操作
					}
				});

				// 待触发 `UniAppJSBridgeReady` 事件后，即可调用 uni 的 API。
				document.addEventListener('UniAppJSBridgeReady', function() {
					console.log('[UniAppJSBridgeReady] 桥接初始化成功');


					document.querySelector('.bottom_buttons').addEventListener('click', function(evt) {
						var target = evt.target;
						if (target.tagName === 'BUTTON') {
							var action = target.getAttribute('data-action');
							console.log('点击按钮:', action);
							// 弹出 toast 显示点击了哪个按钮
							//	alert('点击了：' + action);

							if (!self.uid_str || self.uid_str === 'null' || self.uid_str === 'undefined') {
								self.isLogin = true;

								setTimeout(() => {

									self.isLogin = false;
									uni.navigateTo({
										url: "/pages/login/login"
									});
								}, 1000);

								return;
							}

							if (self.video_type === 1) {

								switch (action) {

									case 'navigateTo':
										if (!self.coverURL) {
											self.isFile = true;

											setTimeout(() => {
												self.isFile = false;

											}, 1000);

											return; // 阻止继续执行
										}

										const params = {
											coverURL: encodeURIComponent(self.coverURL || ''),
											videoid: encodeURIComponent(self.videoId || ''),
											videoUrl: encodeURIComponent(self.videoUrl || ''),
											id: self.id || ''
										};
										const paramString =
											`?coverURL=${params.coverURL}&videoid=${params.videoid}&videoUrl=${params.videoUrl}&id=${params.id}`;

										uni.navigateTo({
											url: '/pages/savevideo/previewvideo' + paramString
										});
										self.videoUrl = '';
										self.url = '';
										self.coverURL = '';
										self.coverURL2 = '';
										self.videoSource = '';
										self.id = '';
										self.statusText = '';
										self.uploading = false; // 上传完成，隐藏进度条
										self.processing = false; // 上传完成，显示“处理中”
										self.authProgress = 0
										//self.is_shiming = '';
										break;
									case 'switchTab':

										// setTimeout(() => {
										// 	self.report_errors = "取消按钮";
										// 	self.isError = true;
										// }, 1000);
										self.uploader.stopUpload()
										self.authProgress = 0
										self.uploadDisabled = false

										self.url = '';
										self.coverURL = '';
										self.coverURL2 = '';
										self.videoSource = '';
										self.id = '';
										//	self.is_shiming = '';
										self.videoUrl = '';
										self.statusText = '';
										self.uploading = false; // 上传完成，隐藏进度条
										self.processing = false; // 上传完成，显示“处理中”
										// 加入这一句：重新加载当前页面
										//	location.reload();

										self.isImageSelected = false;
										self.images = []
										self.statusText = '已选择 ' + self.images.length + ' 张图片';
										break;

								}
							} else if (self.video_type === 2) {

								switch (action) {

									case 'navigateTo':
										if (!self.coverURL2) {
											self.isFile = true;

											setTimeout(() => {
												self.isFile = false;
											}, 1000);

											return;
										}
										const params = {
											coverURL2: encodeURIComponent(self.coverURL2 || ''),
											videoid: encodeURIComponent(self.videoId || ''),
											videoUrl: encodeURIComponent(self.videoUrl || ''),
											id: self.id || ''
										};
										const paramString =
											`?coverURL=${params.coverURL2}&videoid=${params.videoid}&videoUrl=${params.videoUrl}&id=${params.id}`;

										uni.navigateTo({
											url: '/pages/savevideo/previewvideo' + paramString
										});
										self.videoUrl = '';
										self.url = '';
										self.coverURL = '';
										self.coverURL2 = '';
										self.videoSource = '';
										self.id = '';
										self.statusText = '';
										//self.is_shiming = '';
										self.uploading = false; // 上传完成，隐藏进度条
										self.processing = false; // 上传完成，显示“处理中”
										self.authProgress = 0
										break;
									case 'switchTab':
										self.uploader.stopUpload()
										self.authProgress = 0
										self.uploadDisabled = false

										self.url = '';
										self.coverURL = '';
										self.coverURL2 = '';
										self.videoSource = '';
										self.id = '';
										//self.is_shiming = '';
										self.videoUrl = '';
										self.statusText = '';
										self.uploading = false; // 上传完成，隐藏进度条
										self.processing = false; // 上传完成，显示“处理中”
										self.isImageSelected = false;
										self.images = []
										self.statusText = '已选择 ' + self.images.length + ' 张图片';
										// 加入这一句：重新加载当前页面
										//location.reload();

										// uni.switchTab({
										// 	url: '/pages/photograph/photograph2'
										// });
										break;

								}
							}



						}
					});

				});
			},

			// 相册选择视频
			async fileChange(e) {
				const that = this;
				console.log("fileChange===" + JSON.stringify(e.target));
				this.video_type = 1
				this.file = e.target.files[0]
				this.videoSource = 'file';
				if (!this.file) {
					alert("请先选择需要上传的文件!")
					return
				}


				// 截取视频第一帧作为封面
				// self.isError = false;
				var Title = this.file.name
				var userData = '{"Vod":{}}'
				if (this.uploader) {
					this.uploader.stopUpload()
					this.authProgress = 0
					this.statusText = "选择文件"
				}
				this.uploader = this.createUploader()
				// if (!this.uploader) {
				// 	console.error("上传器未创建成功，上传中止");


				// 	this.statusText = "上传模块加载失败";

				// 	return
				// }
				console.log(userData)
				this.uploader.addFile(this.file, null, null, null, userData)
				this.uploadDisabled = false
				this.pauseDisabled = true
				this.resumeDisabled = true

				this.statusText = "准备就绪"

			},


			// 获取视频封面（第一帧）并生成 File 对象
			async getVideoCover(file) {
				let self = this

				return new Promise((resolve, reject) => {
					const video = this.$refs.videoEl;
					const canvas = this.$refs.canvasEl;

					const fileURL = URL.createObjectURL(file);
					video.src = fileURL;
					self.statusText = '图片...' + fileURL;

					video.onloadedmetadata = () => {
						video.currentTime = 0; // 跳到视频开头
					};

					video.onseeked = () => {
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;

						const ctx = canvas.getContext("2d");
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

						canvas.toBlob((blob) => {
							if (blob) {
								const coverFile = new File([blob], 'cover.png', {
									type: 'image/png'
								});
								this.coverFile = coverFile;

								URL.revokeObjectURL(fileURL);
								resolve(coverFile);
							} else {
								reject(new Error('无法创建封面文件'));
							}
						}, 'image/png');
					};

					video.onerror = () => {
						alert("视频加载失败，无法提取封面");
						reject(new Error('视频加载失败'));
					};
				});
			},


			// 点击触发input的点击事件
			clickFile() {
				let self = this


				if (!self.uid_str || self.uid_str === 'null' || self.uid_str === 'undefined') {
					self.isLogin = true;

					setTimeout(() => {
						self.isLogin = false;
						uni.navigateTo({
							url: "/pages/login/login"
						});
					}, 1000);

					return;
				}



				//0 未认证 1审核中  2已实名 3驳回
				if (self.is_shiming == 0) {
					self.showModal = true
					self.showModalMessage = '您未实名认证'
					self.showModalBut = '去认证'



				} else if (self.is_shiming == 1) {
					self.videoSource = 'file';
					//location.reload();
					self.video_type = 1
					self.$refs.leftFile.click();
					// ✅ 安全调用 click 方法
					//	self.triggerFileInput();
				} else if (self.is_shiming == 2) {
					//location.reload();
					self.videoSource = 'file';
					self.video_type = 1
					self.$refs.leftFile.click();
					// if (window.uni) {
					// 	// 发消息给 uni-app 宿主页面
					// 	window.uni.postMessage({
					// 		data: {
					// 			action: 'chooseVideoFromApp'
					// 		}
					// 	});
					// } else {
					// 	// Fallback：普通 H5 流程
					// 	//self.$refs.leftFile.click();
					// }
				} else {
					//驳回
					self.showModal = true
					self.showModalMessage = '实名认证已驳回'
					self.showModalBut = '去修改'


				}


			},
			// 触发 input[type=file]
			triggerFileInput() {
				let self = this
				const input = self.$refs.videoInput;
				if (input) {
					setTimeout(() => input.click(), 100); // 避免安卓点击不触发问题
				}
				setTimeout(() => {
					self.report_errors = "点击相册";
					self.isError = true;
				}, 1000);
				self.isError = false;

			},
			// 点击拍摄按钮触发拍摄功能
			clickRecord() {
				let self = this
				if (!self.uid_str || self.uid_str === 'null' || self.uid_str === 'undefined') {
					self.isLogin = true;

					setTimeout(() => {
						self.isLogin = false;
						uni.navigateTo({
							url: "/pages/login/login"
						});
					}, 1000);

					return;
				}


				//0 未认证 1审核中  2已实名 3驳回
				if (self.is_shiming == 0) {
					self.showModal = true
					self.showModalMessage = '您未实名认证'
					self.showModalBut = '去认证'




				} else if (self.is_shiming == 1) {
					//location.reload();
					self.videoSource = 'record';
					self.video_type = 2
					self.$refs.rightFile.click();
				} else if (self.is_shiming == 2) {
					self.videoSource = 'record';
					//location.reload();
					self.video_type = 2
					self.$refs.rightFile.click();
				} else {
					//驳回
					self.showModal = true
					self.showModalMessage = '实名认证已驳回'
					self.showModalBut = '去修改'

				}

			},




			// 拍摄视频功能，适用于小程序和App
			startRecord(e) {
				this.video_type = 2
				this.file = e.target.files[0]
				console.log(JSON.stringify(e.target));
				if (!this.file) {
					alert("请先选择需要上传的文件!")
					return
				}
				self.videoSource = 'record';


				var Title = this.file.name
				var userData = '{"Vod":{}}'
				if (this.uploader) {
					this.uploader.stopUpload()
					this.authProgress = 0
					this.statusText = "拍摄文件"
				}
				this.uploader = this.createUploader()
				console.log(userData)
				this.uploader.addFile(this.file, null, null, null, userData)
				this.uploadDisabled = false
				this.pauseDisabled = true
				this.resumeDisabled = true
				this.statusText = "准备就绪"
			},



			// 保存功能点击事件
			onSave() {
				console.log('保存:', "onSave");
				// 在这里实现保存逻辑，例如保存视频或其他数据
				// if (this.selectedVideo) {
				// 	console.log('选择的视频路径:', this.selectedVideo);
				// }
				// if (this.recordedVideo) {
				// 	console.log('拍摄的视频路径:', this.recordedVideo);
				// }
				//console.log("保存: ", JSON.stringify(this.uploader, null, 2));
				//this.statusText = "保存" + JSON.stringify(this.uploader, null, 2)
				// 然后调用 startUpload 方法, 开始上传
				//if (this.uploader !== null) {
				this.uploader.startUpload()
				this.uploadDisabled = true
				this.pauseDisabled = false
				this.uploading = true; // 开始显示上传进度条
				//	}


			},

			// 获取上传参数
			getVodParam(params) {




				return axios.post('https://app.kachez.cn/interfaces/index/CreateUploadVideo', params)
					.then(response => response.data)
					.catch(error => {
						console.error('获取VOD参数失败:', error);
						throw error;
					});
			},
			getVodVideoParam(params) {




				return axios.post('https://app.kachez.cn/interfaces/index/GetPlayInfo', params)
					.then(response => response.data)
					.catch(error => {
						console.error('获取VOD参数失败:', error);
						throw error;
					});
			},


			// 获取视频封面 File 对象
			async getVideoCoverFile(videoUrl) {
				let self = this
				return new Promise((resolve, reject) => {
					const video = document.createElement('video');
					video.crossOrigin = 'anonymous'; // 跨域处理
					video.src = videoUrl;
					video.muted = true;
					video.playsInline = true;
					video.preload = 'auto';
					self.statusText = '图片====' + videoUrl;
					video.addEventListener('loadedmetadata', () => {
						video.currentTime = 0.1; // 靠近第一帧更稳定
					});

					video.addEventListener('seeked', () => {
						const canvas = document.createElement('canvas');
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

						// 转为 base64
						const dataUrl = canvas.toDataURL('image/png');
						const file = self.dataURLtoFile(dataUrl, 'cover.png');
						self.statusText = '图片=22===' + file;
						resolve(file); // ✅ 返回 File 对象
					});

					video.onerror = (e) => {
						reject(new Error('视频加载失败，请检查视频地址或跨域设置'));
					};

					// 防止被浏览器垃圾回收，可加入 DOM 后隐藏
					document.body.appendChild(video);
					video.style.display = 'none';
				});
			},

			async updateOriginalVideoUrl(VideoId) {
				let self = this

				const params = {
					videoId: VideoId
				};

				const res = await axios.post('https://app.kachez.cn/interfaces/index/GetPlayInfo',
					params);
				const res_video = res.data;
				self.statusText = '视频中...' + VideoId;
				if (res_video.code === 200) {

					self.statusText = '获取视频地址成功...';
					// 视频播放地址判断
					if (res_video.data.playInfoList && res_video.data.playInfoList.playInfo.length > 0) {
						let playList = res_video.data.playInfoList.playInfo;

						// 优先选MP4格式的视频
						let mp4Video = playList.find(v => v.playURL.toLowerCase().endsWith('.mp4'));
						self.url = mp4Video ? mp4Video.playURL : playList[0].playURL; // 没有MP4就取第一个
						self.videoUrl = mp4Video ? mp4Video.playURL : playList[0].playURL;
						// 获取封面图地址
						const videoBase = res_video.data.videoBase;
						// 封面图为 null 时重试
						if (!videoBase.coverURL) {
							self.statusText = '封面未生成，稍后重试...';
							setTimeout(() => {
								self.updateOriginalVideoUrl(VideoId);
							}, 5000);
							return;
						}

						if (self.videoSource === 'file') {
							self.coverURL = videoBase.coverURL;

							console.log("updateVideoUrl====file");
						} else if (self.videoSource === 'record') {
							self.coverURL2 = videoBase.coverURL;

							console.log("updateVideoUrl====record");
						}



						self.updateVideoUrlId(videoBase.coverURL, self.videoUrl, VideoId)


					}


				} else if (res_video.code === 400) {
					self.statusText = '视频转码中...' + VideoId;
					setTimeout(() => {
						self.updateOriginalVideoUrl(VideoId); // ⏳ 重试
					}, 10000);

				} else {
					self.statusText = '获取视频地址失败...';

					self.processing = false;
					console.error('获取VOD获取视频信息失败');
					setTimeout(() => {
						self.processing = false;
					}, 1000);
				}






				// 	const res = await axios.post('https://app.kachez.cn/interfaces/index/getMezzanineInfo',
				// 		params);
				// 	const data = res.data;

				// 	if (data.code === 200) {

				// 		this.url = data.data.mezzanine.fileURL;
				// 		console.log('获取视频地址成功：', this.url);
				// 		self.statusText = '获取视频地址成功...';
				// 		this.VideoId = VideoId;
				// 		this.videoUrl = data.data.mezzanine.fileURL;

				// 		setTimeout(async () => {
				// 			//const blob = await this.fetchRemoteVideoToBlob(this.videoUrl);
				// 			//const coverFile = await this.getVideoCoverFile(blob);
				// 			const coverFile = await this.getVideoCoverFile(this.videoUrl); // 获取封面 File
				// 			await this.uploadCover(coverFile, this.url); // 上传封面图
				// 		}, 1000);



				// 		// 获取第一帧封面图并转为 File 对象
				// 		//const coverFile = await this.getVideoCoverFile(this.url);
				// 		// 上传封面图
				// 		//await this.uploadCover(coverFile);
				// 		// 获取封面
				// 		// const coverBlob = await this.getCoverH5(this.url);
				// 		//	console.log("coverFile==", coverFile);

				// 		// await this.uploadCover(coverBlob); // 注意：加 await，等上传完

				// 	} else {
				// 		console.error('获取VOD获取视频信息失败');
				// 		setTimeout(() => {
				// 			this.processing = false;
				// 		}, 1000);
				// 		self.statusText = '获取视频地址失败...';
				// 	}
				// } catch (err) {
				// 	console.error('获取VOD参数失败:', err);
				// 	self.statusText = '获取视频地址失败2...';
				// 	setTimeout(() => {
				// 		this.processing = false;
				// 	}, 1000);
				// }
			},

			async uploadCover(coverBlob, url) {
				let self = this
				try {
					const formData = new FormData();
					formData.append('file', coverBlob);

					const response = await axios.post('https://app.kachez.cn/interfaces/index/upload',
						formData, {
							headers: {
								'Content-Type': 'multipart/form-data'
							}
						});

					const data = response.data;

					if (data.code === 200) {
						self.statusText = '上传封面成功...';
						const uploadedUrl = data.data.picurl || '';

						if (this.videoSource === 'file') {
							this.coverURL = uploadedUrl;
							console.log("封面图设置（文件选择）:", this.coverURL);
						} else if (this.videoSource === 'record') {
							this.coverURL2 = uploadedUrl;
							console.log("封面图设置（录制）:", this.coverURL2);
						}

						//this.updateVideoUrlId(uploadedUrl, url)
					} else {
						self.statusText = '上传封面失败...';
						console.error('上传封面失败:', data.message || data);
					}
				} catch (error) {
					self.statusText = '上传封面异常...';
					console.error('上传封面异常:', error);
				}
			},
			async updateVideoUrlId(picurl, url, videoId) {
				let self = this
				try {
					const params = {
						uid: this.uid_str,
						videoUrl: url,
						picurl: picurl,
						videoId: videoId
					};

					const res = await axios.post('https://app.kachez.cn/interfaces/video/add',
						params);
					const data = res.data;

					if (data.code === 200) {

						self.statusText = '添加封面成功...';
						setTimeout(() => {
							this.processing = false;
						}, 1000);
						this.id = data.data.id

					} else {
						self.statusText = '添加视频' + data.msg;
						setTimeout(() => {
							this.processing = false;
						}, 1000);
						console.error('获取VOD获取视频信息失败');
					}
				} catch (err) {
					setTimeout(() => {
						this.processing = false;
					}, 1000);
					console.error('获取VOD参数失败:', err);
				}
			},





			updateHeader(params) {

				return axios.post('https://app.kachez.cn/interfaces/index/upload', params)
					.then(response => response.data)
					.catch(error => {
						console.error('获取VOD参数失败:', error);
						throw error;
					});
			},

			createUploader(type) {
				let self = this

				let uploader = new AliyunUpload.Vod({
					timeout: 90000,
					partSize: 1048576,
					parallel: 5,
					retryCount: 3,
					retryDuration: 2,
					region: self.region,
					userId: self.userId,
					localCheckpoint: true, //此参数是禁用服务端缓存，不影响断点续传
					// 添加文件成功
					addFileSuccess: function(uploadInfo) {
						self.uploadDisabled = false
						self.resumeDisabled = false
						self.statusText = '添加文件成功, 等待上传...'
						self.uploadProgress = 0;
						console.log("addFileSuccess: " + uploadInfo.file.name)
						console.log("addFileSuccess Info: ", JSON.stringify(uploadInfo,
							null, 2));
						//开始上传
						self.onSave();


					},
					// 开始上传
					onUploadstarted: function(uploadInfo) {

						let self = this;
						const params = {
							fileName: uploadInfo.file.name
						};

						axios.post(
								'https://app.kachez.cn/interfaces/index/CreateUploadVideo',
								params)
							.then((res) => {

								const data = res.data;
								if (data.code === 200) {
									self.statusText = '文件开始上传...';

									let uploadAuth = data.data.UploadAuth;
									let uploadAddress = data.data.UploadAddress;
									self.VideoId = data.data.VideoId;

									//console.log("getVodParam====" + uploadAuth + "===" + self.VideoId);

									uploader.setUploadAuthAndAddress(uploadInfo,
										uploadAuth, uploadAddress,
										self.VideoId);
								} else {
									console.error('获取视频信息失败:');
								}
							})
							.catch((err) => {
								console.error('获取参数失败:', err);
							});


						// self.getVodParam({
						// 	fileName: uploadInfo.file.name
						// }).then(res => {
						// 	self.statusText = '文件开始上传...'
						// 	let uploadAuth = res.data.UploadAuth
						// 	let uploadAddress = res.data.UploadAddress

						// 	self.VideoId = res.data.VideoId
						// 	console.log("getVodParam====" + self.VideoId)

						// 	uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,
						// 		self.VideoId)
						// })


					},
					// 文件上传成功

					onUploadSucceed: function(uploadInfo) {
						console.log("onUploadSucceed Info: ", uploadInfo.videoId);
						self.fileName = uploadInfo.file.name;
						self.$emit('getVideoId', self.videoId);
						self.$emit('showVideo', uploadInfo.file.name);
						self.statusText = '文件上传成功!' + uploadInfo.videoId;
						self.uploading = false; // 上传完成，隐藏进度条
						self.processing = true; // 上传完成，显示“处理中”
						self.VideoId = uploadInfo.videoId;

						setTimeout(() => {

							self.updateOriginalVideoUrl(uploadInfo.videoId)
						}, 20000);





					},
					// 文件上传失败
					onUploadFailed: function(uploadInfo, code, message) {
						console.log("onUploadFailed: file:" + uploadInfo.file.name +
							",code=====:" + code +
							", message===:" + message)
						self.statusText = '文件上传失败!'
						self.uploading = false; // 上传失败，隐藏进度条
						self.uploadProgress = 0;

						setTimeout(() => {
							self.report_errors = "文件上传失败：" + message;
							self.isError = true;
						}, 1000);
						self.isError = false;
					},
					// 取消文件上传
					onUploadCanceled: function(uploadInfo, code, message) {
						console.log("Canceled file: " + uploadInfo.file.name +
							", code: " + code +
							", message:" + message)
						self.statusText = '文件已暂停上传'
						self.uploadProgress = 0;
						self.uploading = false; // 上传失败，隐藏进度条
					},
					// 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
					onUploadProgress: function(uploadInfo, totalSize, progress) {
						//	console.log("onUploadProgress Info: ", JSON.stringify(uploadInfo, null, 2));
						console.log("onUploadProgress:file:" + uploadInfo.file.name +
							", fileSize:" +
							totalSize + ", percent:" + Math.ceil(progress * 100) +
							"%")
						let progressPercent = Math.ceil(progress * 100)
						//self.authProgress = progressPercent
						self.statusText = '文件上传中...'


						// 更新进度数据（可用于页面显示）
						self.uploadProgress = progressPercent;



					},
					// 上传凭证超时
					onUploadTokenExpired: function(uploadInfo) {


						self.statusText = '文件超时...'
					},
					// 全部文件上传结束
					onUploadEnd: function(uploadInfo) {
						self.uploadProgress = 0;
						self.statusText = '文件上传完毕'

						self.uploading = false; // 上传完成，隐藏进度条
						self.processing = true; // 上传完成，显示“处理中”

						// setTimeout(() => {

						// 	self.updateOriginalVideoUrl(self.VideoId)
						// }, 20000);

					}
				})
				return uploader
			}
		}
	};
</script>

<style scoped>
	/* 可根据需求添加样式 */
	.hide_file {}

	.camera {
		position: relative;
		z-index: 2;
		margin: 0 auto;

		border-radius: 6px;
		text-align: center;



	}

	.icon {
		width: 260px;
		height: 120px;
	}

	.text {
		display: block;
		line-height: 22px;
		font-size: 15px;
		color: #999;

	}

	.btn-list {}

	.btn {
		display: block;
		margin: 20px auto;
		padding: 5px;
		background-color: #007aff;
		border: 0;
		color: #ffffff;
		height: 40px;
		width: 200px;
	}

	.bottom_buttons {
		margin-top: 70px;
		position: fixed;
		bottom: 90px;
		left: 0;
		width: 90%;
		display: flex;
		justify-content: space-between;
		z-index: 1002;
		margin-left: 15px;
		margin-right: 15px;
	}

	.button {
		width: 40%;
		height: 55px;
		border-radius: 7px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
		font-size: 16px;
		border: 2rpx solid #0977F8;
	}

	.cancel_but {
		background-color: #CCCCCC;
	}

	.next_but {
		border: 2rpx solid #0977F8;
		background-color: #0977F8;
	}

	.button_text {
		color: white;
		font-size: 16px;
	}

	.tab-bar {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 60px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background-color: #ffffff;
		border-top: 1px solid #e5e5e5;
		z-index: 999;
	}

	.tab-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.tab-icon {
		width: 25px;
		height: 25px;
	}

	.modal {
		position: fixed;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999;

	}

	.modal-content {
		left: 20px;
		background: white;
		padding: 20px 30px;
		border-radius: 8px;
		margin-left: 50px;
		margin-right: 50px;
		text-align: center;
	}

	button {
		padding: 10px 20px;
		font-size: 16px;
	}

	.hide {
		display: none;
	}

	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal-container {
		background: #fff;
		padding: 20px;
		border-radius: 6px;
		width: 300px;
		text-align: center;
	}

	.modal-footer {
		margin-top: 20px;
		display: flex;
		justify-content: space-around;
	}

	.modal-footer button {
		padding: 6px 16px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}

	.image-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.image-wrapper {
		position: relative;
		width: calc(33.33% - 10px);
		/* 每行三个，减去间距 */
		padding-top: 33.33%;
		/* 使 div 高度等于宽度，实现正方形 */
		overflow: hidden;
	}

	.image {
		position: absolute;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	/* 删除按钮样式 */
	.delete-btn {
		position: absolute;
		top: 5px;
		right: 5px;
		width: 20px;
		height: 20px;

		cursor: pointer;

		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>